import React from 'react';
import { useLocation } from 'react-router-dom';
import useMetadadosPagina from 'hooks/useMetadadosPagina';

/**
 * Página exibida quando o site está fora do ar (rota /manutencao e chave global do App.jsx).
 *
 * Era o único arquivo do projeto escrito inteiramente em objetos de `style` inline: o rosa da
 * marca cravado em seis lugares, tamanhos (0.95rem, 1.25rem, 2.5rem) que não correspondiam a
 * degrau nenhum da escala, o único `font-weight: 300` do código, e um `<style>` com as keyframes
 * reinjetado a cada render. As keyframes agora vivem em styles/index.css, junto das outras.
 *
 * O título era um <h3> — a página pulava h1 e h2 e abria a estrutura no terceiro nível.
 */
export default function Manutencao() {
    const { pathname } = useLocation();

    // `noindex` só na URL /manutencao. Com a API fora, esta tela ocupa o lugar de QUALQUER rota
    // (early return do AppRoutes) — inclusive da Home. Se o Googlebot passasse numa janela dessas e
    // lesse noindex, tiraria do índice a página que estava visitando, não esta.
    useMetadadosPagina({ titulo: 'Em manutenção | Nova Faxina', indexar: pathname !== '/manutencao' });

    return (
        <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-[#FFFCFD] to-[#FDE8F2] p-5">
            {/* Círculos decorativos do fundo */}
            <div
                aria-hidden="true"
                className="absolute -right-12 -top-24 h-[300px] w-[300px] rounded-full bg-white opacity-10"
            />
            <div
                aria-hidden="true"
                className="absolute -bottom-12 -left-8 h-[200px] w-[300px] rounded-full bg-white opacity-10"
            />

            <div className="relative z-10 max-w-[600px] text-center">
                <div className="mx-auto mb-8 flex h-[120px] w-[120px] animate-halo items-center justify-center rounded-full border-2 border-primary/30 bg-primary/10">
                    <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M30 5C16.7 5 6 15.7 6 29C6 42.3 16.7 53 30 53C43.3 53 54 42.3 54 29C54 15.7 43.3 5 30 5ZM30 48C19.5 48 11 39.5 11 29C11 18.5 19.5 10 30 10C40.5 10 49 18.5 49 29C49 39.5 40.5 48 30 48Z"
                            fill="#D9466E"
                        />
                        <path
                            d="M30 15C21.7 15 15 21.7 15 30C15 38.3 21.7 45 30 45C38.3 45 45 38.3 45 30"
                            stroke="#D9466E"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                        <path
                            d="M30 20V30L38 38"
                            stroke="#D9466E"
                            strokeWidth="2"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>

                <a href="/">
                    <img
                        src="/images/logo.svg"
                        alt="Nova Faxina"
                        className="mx-auto mb-10 block w-full max-w-[400px] animate-flutuar object-contain drop-shadow-[0_10px_20px_rgba(0,0,0,0.2)]"
                    />
                </a>

                <h1 className="t-display mb-5 text-primary">
                    Pausa para arrumar a casa
                </h1>

                <p className="t-lead mb-10 text-dark">
                    Estamos aplicando melhorias importantes para deixar tudo mais simples e limpo.
                </p>

                <p className="badge mt-5 border border-primary/30 bg-primary/10 px-5 py-2.5 text-sm text-primary">
                    ⏱️ Voltaremos em breve
                </p>

                <p className="t-apoio mt-16">
                    Obrigado pela sua paciência e compreensão!
                </p>
            </div>
        </div>
    );
}
